<template>
 
 <div class="faixa bg-verde-esc">
  </div>
 
  <div class="row bg-verde-esc">
    <div class="col-12 col-md-6 ">
      <div class="content">
        <h1 class="cor-azul">Drink the air</h1>
        <span class="amarelo f-4">
          <br>
          In a world that rushes, AWA invites you to pause. To feel the Amazonian rain in every drop, to hear the whisper of the trees in every sip.
          <br><br>
          It’s not just hydration; it’s a pause, a moment of connection with the earth that sustains us. It’s simplicity found in the complexity of nature.
        </span>
      </div>
    </div>
    <div class="col-12 col-md-6" style="text-align: right;">
      <img class="img-fluid" :src="'awa-bottles.jpg'" alt="AWA Bottles">
    </div>
  </div>
  <div class="faixa bg-verde-esc">
  </div>
 
</template>

<script>
export default {
}
</script>

<style scoped>
:root {
  --cream: #E0D0A6;
  --blue: #6FD0E7;
  --blue2: #83DEF4;
  --green: #536D3F;
  --mid-green: #475C37;
  --dark-green: #3D4D31;
  --object-sans: 'Object Sans', Arial, Helvetica, sans-serif;
}

.bg-verde-esc {
  background-color: var(--dark-green);
}

.cor-azul {
  color: var(--blue);
}

.amarelo {
  color: var(--cream);
}

 
h1 {
  font-family: var(--object-sans);
  font-size: 6rem;
  font-weight: 400;
}

.f-4 { font-size: 2.5rem; letter-spacing: 0.06rem; line-height: 3.2rem;} /* Um pouco menor */

 
.img-fluid {
    max-width: 100%;
    height: auto;
    margin: 0 auto;
}
 
.faixa {
  padding: 8rem;
}


/* SE FOR NA TELA DE CELULAR PEQUENA */

@media screen and (max-width: 640px) {
  .faixa {
  padding: 2rem;
}

  h1 {
    font-size: 4rem;
  }

  .border-log {
      border: 4px solid rgb(0, 0, 255);
  }

  .content {
    padding: 2rem;
    margin: 2rem;
    text-align: left;
  }

  .row {
    flex-direction: column;
    text-align: center;
  }

  .col-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .col-md-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .f-4 { font-size: 2.0rem; letter-spacing: 0.04rem; line-height: 2.4rem;} /* Um pouco menor */

 
}







/* SE FOR NA TELA GRANDE */

@media screen and (min-width: 641px) {

  .content {
    padding: 8rem;
    margin: 8rem;
    text-align: left;
  }

  .border-log {
      border: 4px solid red;
  }


}
</style>
